export default "__VITE_ASSET__RfekvOqK__"